<script setup lang="ts">
import BaseDropdown from '@/components/base/BaseDropdown.vue'
import BaseActionMenuButton from '@/components/base/menus/BaseActionMenuButton.vue'
import { createRandomUuid } from '@/helpers/functions'
import { useI18n } from 'vue-i18n'

interface Props {
  /** Array of action menu items */
  actions: ActionMenuItem[]
}

defineProps<Props>()

const { t } = useI18n()

const id = createRandomUuid()
</script>

<template>
  <BaseDropdown :id>
    <template #button="{ toggle, open }">
      <!-- TOGGLER BUTTON -->
      <IconButton
        class="action-menu-toggler"
        :aria-label="
          open ? t('general.hide_all_actions') : t('general.show_all_actions')
        "
        :icon="open ? '$close' : '$dots-vertical'"
        @click.stop="toggle"
      />
    </template>
    <!-- DROPDOWN MENU -->
    <div
      v-if="actions.length"
      class="rounded-md border border-secondary-200 bg-white py-1"
    >
      <BaseActionMenuButton
        v-for="(action, index) in actions"
        :key="index"
        :icon="action.icon"
        :label="action.label"
        @click.stop="$emit(action.event.replace(/_/g, '-'), action.params)"
      />
    </div>
  </BaseDropdown>
</template>
